import {store} from "../store";
import {isProductDisabled} from "../libraries/utils";
import _ from "lodash";
import {isMenu, isSpecificProductGroupType} from "../domains2/libraries/Utils";
import ProductSelection from "../domains2/orders/ProductSelection";
import OrderHelperObject from "../domains2/orders/OrderHelperObject";

export const filterProductSelectionsByAvailability = (payload) => {
	return payload.productSelections.filter(ps => {
		// filter our complex product if some subproduct is not available
		if (ps.groups && ps.groups.length) {
			const allProductsInGroupsAvailable = ps.groups.every(group => {
				// no product in groups were selected
				if (!group.selectedProducts.length) {
					return true;
				}
				return group.selectedProducts.every(selectedSubProduct => {
					const subProductId = typeof selectedSubProduct === "string"
						? selectedSubProduct
						: selectedSubProduct && selectedSubProduct.productId;
					try {
						const subProductSelection = ProductSelection.createFromProduct(payload.productCatalog.getProduct(subProductId));
						return OrderHelperObject.canBePickedUp({
							boxDate: payload.date,
							productSelections: [subProductSelection],
							tenantData: payload.tenantData,
							pickupDateTimeRules: payload.pickupDateTimeRules,
							shopId: payload.shopId,
							includeDisabled: true,
							productCatalog: payload.productCatalog,
							hiddenItems: store.getters.aBTestsHiddenItems
						});
					} catch (e) {
						// if some products are disabled they will not be part of the product catalog and an error will be thrown
						// we will just ignore them
						return false;
					}
				});
			});
			if (!allProductsInGroupsAvailable) {
				return false;
			}
		}
		try {
			// filter the single product if disabled
			return OrderHelperObject.canBePickedUp({
				boxDate: payload.date,
				productSelections: [ps],
				tenantData: payload.tenantData,
				pickupDateTimeRules: payload.pickupDateTimeRules,
				shopId: payload.shopId,
				includeDisabled: true,
				productCatalog: payload.productCatalog,
				hiddenItems: store.getters.aBTestsHiddenItems
			});
		} catch (e) {
			// if some products are disabled they will not be part of the product catalog and an error will be thrown
			// we will just ignore them
			return false;
		}
	});
};

export const noThanksObject = {
	id: "999999",
	name: "No thanks",
	imageLinks: ["123T144/nej-tak-v1-cropped.png", "123T144/nej-tak-v1-cropped_thumb.png"]
};

export const isNoThanksProductId = (id) => {
	if(!id) {
		return false;
	}
	const product = store.getters.productCatalog.getProduct(id, true);
	return isNoThanksProduct(product);
};

export const isNoThanksProduct = (product) => {
	if (isProductDisabled(product)) {
		return false;
	}
	return product.options.isNoThanks;
};
export const containsNoThanks = (group) => {
	return group.products.find(product => {
		return isNoThanksProduct(product);
	});
};
export const mapGroups = (productCatalog, item, callbackFn) => {
	if(item.groups) {
		return item.groups.map(group => {
			const isMenuProduct = group.productId ? isMenu(productCatalog, group.productId) : false;
			if(isMenuProduct) {
				const newProduct = group.products.length === 1 ? group.products[0] : {};
				mapGroups(productCatalog, newProduct, callbackFn);
			} else {
				return callbackFn(group);
			}
		});
	} else {
		return item;
	}
};
export const differentiateGroup = (group) => {
	const splitProducts = (array, callback) =>
		array.filter(product => product.isActive)
			.reduce((acc, item) => {
				acc[callback(item) ? 0 : 1].push(item);
				return acc;
			}, [[], []]);
	const [upsellProducts, defaultProducts] = splitProducts(group.products, (p => _.get(p, ["productGroupDetails", group.id, "additionalDetails", "upsellProduct"])));

	const {globalSelectedShop, featureToggles} = store.getters;

	const upsellProductsWithNoThanks = upsellProducts.length > 0 && !(featureToggles.newAddonsDesignAndFlow && globalSelectedShop.shopOptions.newAddonsDesign)
		? [...upsellProducts, noThanksObject]
		: upsellProducts;
	const defaultProductWithNoThanks = upsellProducts.length === 0 && defaultProducts.length > 0 && !(featureToggles.newAddonsDesignAndFlow && globalSelectedShop.shopOptions.newAddonsDesign)
		? [...defaultProducts, noThanksObject]
		: defaultProducts;

	return {
		...group,
		products: {
			upsell: upsellProductsWithNoThanks,
			default: defaultProductWithNoThanks
		}
	};
};
export const generateDifferentiatedGroups = (item) => {
	mapGroups(store.getters.productCatalog, item, (group) => {
		let differentiatedGroup = {};
		const hasUpsellProducts = !isSpecificProductGroupType(group, "addons") && group.products.find(p => _.get(p, ["productGroupDetails", group.id, "additionalDetails", "upsellProduct"]));
		if(hasUpsellProducts) {
			differentiatedGroup = differentiateGroup(group);
			item.differentiatedGroup = differentiatedGroup;
		}
		return hasUpsellProducts ? differentiatedGroup : group;
	});
};

export function getProductIdsFromOrderLines(data) {
	const productIds = [];
	function traverse(obj) {
		if (Array.isArray(obj)) {
			obj.forEach(item => traverse(item));
		} else if (typeof obj === "object" && obj !== null) {
			if ("productId" in obj && typeof obj.productId === "string") {
				productIds.push(obj.productId);
			}
			Object.values(obj).forEach(value => traverse(value));
		}
	}
	traverse(data);
	return productIds.filter((value, index, self) => self.indexOf(value) === index);
}
